<template>
  <header class="border boder-black fixed bg-white z-50 w-full">
    <div class="container mx-auto">
      <div class="h-16 w-full py-2 flex">
        <div class="w-1/2 md:w-2/3 flex justify-start items-center">
          <router-link :to="{path: `/${locale === 'es' ? locale : '' }`}">
            <img @click="homeClicked" class="w-48 mr-16 pl-2 pr-4 lg:pr-0" src="/logo.svg" alt />
          </router-link>
          <p
            class="m-0 p-0 font-bold text-xl text-black-darkest hidden lg:block"
          >{{ $t('messages.general.page_title')}}</p>
        </div>
        <div class="w-1/2 md:w-1/3 flex justify-end items-center">
          <router-link
            class="mx-4 text-black font-semibold no-underline hidden lg:block hover:text-gray-600"
            :to="{path: `/${locale === 'es' ? locale : '' }`}"
          >
            <span @click="homeClicked">{{ $t('messages.general.home') }} </span>
          </router-link>
          <router-link
            class="mx-4 text-black font-semibold no-underline hidden lg:block hover:text-gray-600"
            to="/support"
          >{{ $t('messages.general.support') }}</router-link>
          <template v-if="user">
            <template v-if="user.username">
              <router-link
                class="hover:text-blue-500 mx-4 bg-blue-500 no-underline text-white font-semibold rounded px-5 py-2 hover:bg-white hover:text-blue-500 border hover:border-blue-500"
                to="/subscriptions"
              >{{ $t('messages.general.subscribe') }}</router-link>
              <div class="dropdown px-4 no-list">
                <div
                  class="dropdown__header w-24 flex items-center mr-5"
                  v-bind:class="{ 'is-showProfile': isShow }"
                  @click="toggleDropdownProfile()"
                >
                  <img
                    v-if="user.pictures.length > 0"
                    class="rounded-full h-10 w-10 object-cover"
                    :src="coverUrl"
                    alt
                  />
                  <img
                    v-else
                    class="rounded-full h-10 w-10 object-cover"
                    src="/storage/image/placeholder-user.jpg"
                    alt
                  />

                  <a class="no-underline font-semibold text-black px-2 flex">
                    {{ $t('messages.general.profile') }}
                    <span class="text-blue-dark ml-2">▾</span>
                  </a>
                </div>
                <div class="dropdown__content absolute -ml-16 bg-gray-300 rounded mt-4">
                  <ul class="no-list px-2 leading-loose">
                    <router-link to="/profile" class="no-underline">
                      <p
                        @click="isShow = false"
                        class="hover:text-blue-400 text-gray-700 font-semibold"
                      >{{ $t('messages.general.profile') }}</p>
                    </router-link>
                    <router-link to="/edit-profile" class="no-underline">
                      <p
                        @click="isShow = false"
                        class="hover:text-blue-400 text-gray-700 font-semibold"
                      >{{ $t('messages.general.edit_profile') }}</p>
                    </router-link>
                    <router-link
                      to="/state-subscription"
                      class="no-underline"
                      v-if="(user) ? user.subscription_status === 'active': null"
                    >
                      <p
                        @click="isShow = false"
                        class="hover:text-blue-400 text-gray-700 font-semibold"
                      >{{ $t('messages.general.subscription_status') }}</p>
                    </router-link>
                    <router-link to="/blocked-profile" class="no-underline">
                      <p
                        @click="isShow = false"
                        class="hover:text-blue-400 text-gray-700 font-semibold"
                      >{{ $t('messages.general.locked_profiles') }}</p>
                    </router-link>
                    <router-link to="/renewal-subscription" class="no-underline">
                      <p
                        @click="isShow = false"
                        class="hover:text-blue-400 text-gray-700 font-semibold"
                      >{{ $t('messages.general.subscription_renewal') }}</p>
                    </router-link>
                    <a class="cursor-pointer focus:outline-none" @click="sessionLogout">
                      <span
                        @click="isShow = false"
                        class="hover:text-blue-400 text-gray-700 font-semibold"
                      >{{ $t('messages.general.logout') }}</span>
                    </a>
                  </ul>
                </div>
              </div>
            </template>
            <template v-else>
              <router-link
                class="mx-1 sm:mx-4 bg-jblue-primary md:text-md text-white font-semibold rounded px-2 sm:px-8 py-1 sm:py-2 border hover:bg-white hover:border-jblue-primary hover:text-jblue-primary"
                to="/login"
              >{{ $t('messages.general.login') }}</router-link>
            </template>
          </template>
          <template v-if="!user">
            <router-link
              class="mx-1 sm:mx-4 bg-jblue-primry md:text-md text-white font-semibold rounded px-2 sm:px-8 py-1 sm:py-2 border hover:bg-white hover:border-jblue-primary hover:text-jblue-primary"
              to="/login"
            >{{ $t('messages.general.login') }}</router-link>
          </template>
          <select
            name="language"
            :value="locale"
            v-model="language"
            @change="changeLocale"
            class="focus:outline-none cursor-pointer appearance-none py-1 md:py-2 font-semibold px-2 md:px-4 mr-2 text-xs md:text-md bg-gray-200 rounded"
          >
            <option value="es">{{$t('messages.languages.spanish') }}</option>
            <option value="en">{{$t('messages.languages.english') }}</option>
          </select>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Cookies from "js-cookie";
import bus from "@/bus";

export default {
  name: "Toolbar",
  data() {
    return {
      isOpen: false,
      isShow: false,
      isActive: false,
      stateMenu: 0,
      stateMenuProfile: 0,
      language: Cookies.get("locale") ? Cookies.get("locale") : "en"
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("locale", ["locale"]),
    coverUrl() {
      const picture = this.user.pictures.filter(
        photo => photo.status === "approved" && photo.cover === 1
      );
      if (picture.length > 0) {
        return picture[0].url;
      }
      return "/storage/image/placeholder-user.jpg";
    }
  },
  created() {
    document.addEventListener("click", this.showProfileOptions);
  },
  destroyed() {
    document.removeEventListener("click", this.showProfileOptions);
  },
  methods: {
    ...mapActions("locale", ["setLocale"]),
    ...mapActions("auth", ["fetchUser", "logout"]),
    ...mapActions("profiles", ['setPaginationPage', 'storeSearchParams']),
    homeClicked() {
      this.setPaginationPage(1);
      this.storeSearchParams({});
    },
    changeLocale(e) {
      this.$router.push({ params: {
        lang: e.target.value
      }});

      this.setLocale(e.target.value);
    },
    sessionLogout() {
      this.$emit("logout");
    },
    showProfileOptions(e) {
      if (this.isShow == true && this.stateMenuProfile == 1) {
        this.isShow = false;
        this.stateMenuProfile = 0;
      }
      this.stateMenuProfile = 1;
    },
    hideDropdowns(e) {
      this.isActive = false;
      this.isShow = false;
    },
    toggleDropdown() {
      if (this.isShow) {
        this.isShow = false;
      }
      if (this.isActive == true) {
        this.isActive = false;
        this.stateMenu = 0;
      } else {
        this.isActive = true;
        this.stateMenu = 2;
      }
    },
    toggleDropdownProfile() {
      if (this.isActive) {
        this.isActive = false;
      }
      if (this.isShow == true) {
        this.isShow = false;
        this.stateMenuProfile = 0;
      } else {
        this.isShow = true;
        this.stateMenuProfile = 2;
      }
    }
  }
};
</script>
